import React from "react";

export default function PageHeader({ title, subtitle, actions, testId }) {
    return (
        <div
            className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between mb-4 md:mb-6"
            data-testid={testId || "page-header"}
        >
            <div>
                <h2 className="text-xl md:text-2xl font-semibold text-gray-900 tracking-tight">
                    {title}
                </h2>
                {subtitle && (
                    <p className="text-sm text-gray-500 mt-0.5">{subtitle}</p>
                )}
            </div>
            {actions && <div className="flex gap-2 flex-wrap">{actions}</div>}
        </div>
    );
}
